import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/domains';
import { AUTHENTICATION_REPOSITORY } from '../../core/domain';
import { AUTH_API } from '../data-sources';
import { ErrorResultHandler } from '@lib/domain-common';
export var AuthenticationRepository = /*#__PURE__*/function () {
  function AuthenticationRepository(authApi) {
    _classCallCheck(this, AuthenticationRepository);

    this.authApi = authApi;
  }

  _createClass(AuthenticationRepository, [{
    key: "verifyAccessToken",
    value: function () {
      var _verifyAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var accessToken, accessId, responseOrError, output;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                accessToken = localStorage.getItem("access_token_".concat(input.clientId));
                accessId = localStorage.getItem("access_id_".concat(input.clientId));
                _context.next = 4;
                return this.authApi.verifyAccessToken({
                  accessToken: accessToken
                });

              case 4:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", ErrorResultHandler(responseOrError));

              case 7:
                output = {
                  accessId: accessId,
                  isValid: responseOrError.getValue().isValid
                };
                return _context.abrupt("return", Result.ok(output));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function verifyAccessToken(_x) {
        return _verifyAccessToken.apply(this, arguments);
      }

      return verifyAccessToken;
    }()
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, _responseOrError$getV, accessToken, profile, authenticationResponse;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.authApi.getAccessToken(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                _responseOrError$getV = responseOrError.getValue(), accessToken = _responseOrError$getV.accessToken, profile = _responseOrError$getV.profile;
                localStorage.setItem('access_token', accessToken);
                localStorage.setItem("access_token_".concat(input.clientId), accessToken);
                localStorage.setItem("access_id_".concat(input.clientId), input.accessId);
                localStorage.setItem('profile', JSON.stringify(profile));
                authenticationResponse = responseOrError.getValue();
                return _context2.abrupt("return", Result.ok(authenticationResponse));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAccessToken(_x2) {
        return _getAccessToken.apply(this, arguments);
      }

      return getAccessToken;
    }()
  }, {
    key: "signIn",
    value: function () {
      var _signIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var responseOrError, _responseOrError$getV2, accessToken, accessId;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.authApi.signIn(input);

              case 2:
                responseOrError = _context3.sent;

                if (!responseOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", mappingResultError(responseOrError));

              case 5:
                _responseOrError$getV2 = responseOrError.getValue(), accessToken = _responseOrError$getV2.accessToken, accessId = _responseOrError$getV2.accessId;
                localStorage.setItem('access_token', accessToken);
                localStorage.setItem("access_token_".concat(input.clientId), accessToken);
                localStorage.setItem("access_id_".concat(input.clientId), accessId);
                return _context3.abrupt("return", Result.ok(responseOrError.getValue()));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function signIn(_x3) {
        return _signIn.apply(this, arguments);
      }

      return signIn;
    }()
  }, {
    key: "signInByGoogle",
    value: function () {
      var _signInByGoogle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var responseOrError, _responseOrError$getV3, accessToken, accessId;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.authApi.signInByGoogle(input);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", mappingResultError(responseOrError));

              case 5:
                _responseOrError$getV3 = responseOrError.getValue(), accessToken = _responseOrError$getV3.accessToken, accessId = _responseOrError$getV3.accessId;
                localStorage.setItem('access_token', accessToken);
                localStorage.setItem("access_token_".concat(input.clientId), accessToken);
                localStorage.setItem("access_id_".concat(input.clientId), accessId);
                return _context4.abrupt("return", Result.ok(responseOrError.getValue()));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function signInByGoogle(_x4) {
        return _signInByGoogle.apply(this, arguments);
      }

      return signInByGoogle;
    }()
  }, {
    key: "signOutForApp",
    value: function () {
      var _signOutForApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
        var accessToken, responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                accessToken = localStorage.getItem("access_token_".concat(input.clientId));

                if (!accessToken) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 4;
                return this.authApi.signOut({
                  accessToken: accessToken
                });

              case 4:
                responseOrError = _context5.sent;

                if (!responseOrError.isFailure) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", mappingResultError(responseOrError));

              case 7:
                successMessage = responseOrError.getValue();
                localStorage.clear();
                return _context5.abrupt("return", Result.ok(successMessage));

              case 10:
                return _context5.abrupt("return", Result.ok());

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function signOutForApp(_x5) {
        return _signOutForApp.apply(this, arguments);
      }

      return signOutForApp;
    }()
  }, {
    key: "signOutForIdentity",
    value: function () {
      var _signOutForIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                localStorage.clear();
                return _context6.abrupt("return", Result.ok());

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function signOutForIdentity() {
        return _signOutForIdentity.apply(this, arguments);
      }

      return signOutForIdentity;
    }()
  }, {
    key: "signUp",
    value: function () {
      var _signUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(input) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.authApi.signUp(input);

              case 2:
                responseOrError = _context7.sent;

                if (!responseOrError.isFailure) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context7.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function signUp(_x6) {
        return _signUp.apply(this, arguments);
      }

      return signUp;
    }()
  }, {
    key: "confirmation",
    value: function () {
      var _confirmation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(input) {
        var responseOrError, confirmationResponse;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.authApi.confirmation(input);

              case 2:
                responseOrError = _context8.sent;

                if (!responseOrError.isFailure) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", mappingResultError(responseOrError));

              case 5:
                confirmationResponse = responseOrError.getValue();
                return _context8.abrupt("return", Result.ok(confirmationResponse));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function confirmation(_x7) {
        return _confirmation.apply(this, arguments);
      }

      return confirmation;
    }()
  }, {
    key: "forgotPassword",
    value: function () {
      var _forgotPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(input) {
        var responseOrError, successMessage;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.authApi.forgotPassword(input);

              case 2:
                responseOrError = _context9.sent;

                if (!responseOrError.isFailure) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", mappingResultError(responseOrError));

              case 5:
                successMessage = responseOrError.getValue();
                return _context9.abrupt("return", Result.ok(successMessage));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function forgotPassword(_x8) {
        return _forgotPassword.apply(this, arguments);
      }

      return forgotPassword;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(input) {
        var responseOrError, resetPasswordResponse;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.authApi.resetPassword(input);

              case 2:
                responseOrError = _context10.sent;

                if (!responseOrError.isFailure) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return", mappingResultError(responseOrError));

              case 5:
                resetPasswordResponse = responseOrError.getValue(); // Clear access token from local storage

                localStorage.clear();
                return _context10.abrupt("return", Result.ok(resetPasswordResponse));

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function resetPassword(_x9) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }]);

  return AuthenticationRepository;
}();
export var authenticationRepositoryProvider = {
  provide: AUTHENTICATION_REPOSITORY,
  useFactory: function useFactory(authApi) {
    return new AuthenticationRepository(authApi);
  },
  inject: [AUTH_API]
};